import { useLocation } from 'react-router-dom';

export const searchSplitter = (search: string) => {
  if (search && typeof search === 'string' && search.length) {
    const substr = search.substring(1)
    const split = substr.split('&');
    const pairs: { [key: string]: string } = {};

    split.forEach(splitItem => {
      const entry = splitItem.split('=');
      pairs[entry[0]] = entry[1];
    });

    return pairs;
  }

  return { };
};

const useGetURLParameters = () => {
  const location = useLocation();

  if (location && location.search) {
    return searchSplitter(location.search);
  }

  return { };
};

/**
 * Gets url param based attributes for GA tag events.
 * @param eventAttributeKeys - optional params to override default [utm_campaign, utm_medium, utm_source]
 */
export const useGetParamsForGA = (eventAttributeKeys = ['utm_campaign', 'utm_medium', 'utm_source']) => {
  const params = useGetURLParameters();
  const result: { [key: string]: string } = {};

  eventAttributeKeys.forEach(eventAttributeKey => {
    const paramValue = params[eventAttributeKey];
    if (paramValue) {
      result[eventAttributeKey] = paramValue;
    }
  });

  return result;
};

export const modifyWithPersistURLEnv = (newLocation: string) => {
  const params = searchSplitter(window?.location?.search || '');
  const hasNewLocationParams = !!newLocation?.split('?')[1];

  let searchItemToPersist = '';

  if (params && params.env) {
    searchItemToPersist = `${hasNewLocationParams ? '&' : '?'}env=${params.env}`
  }

  return `${newLocation}${searchItemToPersist}`;
};
